import { companyRoutes } from './companies';
import { orderRoutes } from './orders';

export const accountRoutes = [
  {
    path: 'accounts',
    children: [...companyRoutes, ...orderRoutes],
  },
];
